import { render, staticRenderFns } from "./view.vue?vue&type=template&id=00da7cfd"
import script from "./view.ts?vue&type=script&lang=js&external"
export * from "./view.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/1/s/TafStore.PharmUP.Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00da7cfd')) {
      api.createRecord('00da7cfd', component.options)
    } else {
      api.reload('00da7cfd', component.options)
    }
    module.hot.accept("./view.vue?vue&type=template&id=00da7cfd", function () {
      api.rerender('00da7cfd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/duplicacoes/clientesDuplicados/view.vue"
export default component.exports